import React, { useState, useEffect } from "react";
import { useNavLinks, usePostTags } from "../../hooks";
import { fetchGet } from "../../utils";
import { Title } from "..";
import WikiIndexList from "./wiki-index-list";
import WikiTagFilter from "./wiki-tag-filter";

export default function WikiIndex() {
  const { tags } = usePostTags();
  const [wikiList, setWikiList] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);
  const { updateNavButtons } = useNavLinks();

  useEffect(() => {
    updateNavButtons({ hideAll: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateNavButtons]);

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams({ filteredTags });
      const url =
        filteredTags && filteredTags.length > 0
          ? `/api/wiki/wiki?` + params.toString()
          : "/api/wiki/wiki";
      const { body } = await fetchGet({
        url,
        onError: console.error,
      });
      if (body) {
        setWikiList(body.fileList);
      }
    })();
  }, [filteredTags]);

  return wikiList ? (
    <>
      <Title title={"All wiki pages"} />
      <WikiTagFilter
        tags={tags}
        filteredTags={filteredTags}
        setFilteredTags={setFilteredTags}
        showButton={wikiList && wikiList.length > 0}
      />
      <WikiIndexList setWikiList={setWikiList} wikiList={wikiList} />
    </>
  ) : (
    <>
      <Title title={"No wiki pages found"} />
      <h1>No wiki pages found</h1>
    </>
  );
}
